import { Link } from 'react-router-dom';
import { isWwwSite } from '../utils/authRedirect';

export const Team = () => {
  const isWww = isWwwSite();
  
  return (
  <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-100">
    {/* Navigation */}
    <nav className="relative z-10 flex items-center justify-between p-6 lg:px-8">
      <div className="flex items-center">
        <Link to="/" className="flex items-center">
          <div className="w-10 h-10 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-xl flex items-center justify-center shadow-lg">
            <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
            </svg>
          </div>
          <span className="ml-3 text-xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
            Finderz AI
          </span>
        </Link>
      </div>
      <div className="flex items-center gap-4">
        {isWww ? (
          <>
            <a 
              href="https://app.finderz.ai/login"
              className="text-gray-700 hover:text-blue-600 transition duration-300 font-medium"
            >
              Sign In
            </a>
            <a 
              href="https://app.finderz.ai/register"
              className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-2.5 rounded-xl hover:shadow-lg transform hover:scale-105 transition duration-300 font-medium"
            >
              Get Started
            </a>
          </>
        ) : (
          <>
            <Link 
              to="/login" 
              className="text-gray-700 hover:text-blue-600 transition duration-300 font-medium"
            >
              Sign In
            </Link>
            <Link 
              to="/register" 
              className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-6 py-2.5 rounded-xl hover:shadow-lg transform hover:scale-105 transition duration-300 font-medium"
            >
              Get Started
            </Link>
          </>
        )}
      </div>
    </nav>

    {/* Hero Section */}
    <div className="relative px-6 lg:px-8 py-12">
      <div className="mx-auto max-w-4xl text-center">
        <h1 className="text-4xl font-bold tracking-tight text-gray-900 sm:text-6xl">
          Meet Our Team
        </h1>
        <p className="mt-6 text-lg leading-8 text-gray-600 max-w-2xl mx-auto">
          Passionate innovators dedicated to revolutionizing data center construction with AI
        </p>
      </div>
    </div>

    {/* Team Content */}
    <div className="max-w-7xl mx-auto px-6 pb-12">
      {/* Founders & Partners Section - All in one */}
      <section className="mb-16">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">Founders & Partners</h2>
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* CEO */}
          <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl p-6 text-center">
            <div className="w-32 h-32 mx-auto mb-4 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-full flex items-center justify-center">
              <span className="text-4xl font-bold text-white">AT</span>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-1">Aleh Tsikhanau</h3>
            <p className="text-blue-600 font-medium mb-3">CEO & Founder</p>
            <p className="text-gray-600 text-sm mb-4">
              Founder & visionary with 15+ years in building products and teams. 
              Proven operator from infrastructure, finance, and AI.
            </p>
            <div className="flex justify-center gap-3">
              <a href="#" className="text-gray-400 hover:text-blue-600 transition">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                </svg>
              </a>
              <a href="#" className="text-gray-400 hover:text-blue-600 transition">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* CTO */}
          <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl p-6 text-center">
            <div className="w-32 h-32 mx-auto mb-4 bg-gradient-to-r from-purple-600 to-pink-600 rounded-full flex items-center justify-center">
              <span className="text-4xl font-bold text-white">AK</span>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-1">Andrei Kazialetski</h3>
            <p className="text-purple-600 font-medium mb-3">CTO & Co-Founder</p>
            <p className="text-gray-600 text-sm mb-4">
              Technology leader with deep experience in infrastructure and software.
              Building scalable AI-powered solutions.
            </p>
            <div className="flex justify-center gap-3">
              <a href="#" className="text-gray-400 hover:text-purple-600 transition">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                </svg>
              </a>
              <a href="#" className="text-gray-400 hover:text-purple-600 transition">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* CFO */}
          <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl p-6 text-center">
            <div className="w-32 h-32 mx-auto mb-4 bg-gradient-to-r from-green-600 to-teal-600 rounded-full flex items-center justify-center">
              <span className="text-4xl font-bold text-white">VP</span>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-1">Vivian Pham</h3>
            <p className="text-green-600 font-medium mb-3">CFO & Partner</p>
            <p className="text-gray-600 text-sm mb-4">
              Finance leader with 15+ years in operations and CFO roles (Mirapath, oneNav).
              Ensuring financial excellence.
            </p>
            <div className="flex justify-center gap-3">
              <a href="#" className="text-gray-400 hover:text-green-600 transition">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>

        {/* Second row of partners */}
        <div className="grid md:grid-cols-3 gap-8">
          {/* Data Center Founder */}
          <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl p-6 text-center">
            <div className="w-32 h-32 mx-auto mb-4 bg-gradient-to-r from-orange-600 to-red-600 rounded-full flex items-center justify-center">
              <span className="text-4xl font-bold text-white">DLY</span>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-1">Doris Li Yeh</h3>
            <p className="text-orange-600 font-medium mb-3">Founder, Data Center Expertise</p>
            <p className="text-gray-600 text-sm mb-4">
              20+ years in data center operations and strategy.
              Leading infrastructure innovation.
            </p>
            <div className="flex justify-center gap-3">
              <a href="#" className="text-gray-400 hover:text-orange-600 transition">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Cyber Security Founder */}
          <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl p-6 text-center">
            <div className="w-32 h-32 mx-auto mb-4 bg-gradient-to-r from-indigo-600 to-purple-600 rounded-full flex items-center justify-center">
              <span className="text-4xl font-bold text-white">MW</span>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-1">Maitjian Welke</h3>
            <p className="text-indigo-600 font-medium mb-3">Founder, Cyber Security</p>
            <p className="text-gray-600 text-sm mb-4">
              20+ years of Silicon Valley experience building Enterprise Software at SUN, CISCO, IBM, & VMware.
            </p>
            <div className="flex justify-center gap-3">
              <a href="#" className="text-gray-400 hover:text-indigo-600 transition">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                </svg>
              </a>
            </div>
          </div>

          {/* Enterprise AI Architect */}
          <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl p-6 text-center">
            <div className="w-32 h-32 mx-auto mb-4 bg-gradient-to-r from-cyan-600 to-blue-600 rounded-full flex items-center justify-center">
              <span className="text-4xl font-bold text-white">SF</span>
            </div>
            <h3 className="text-xl font-semibold text-gray-900 mb-1">Sergej Fedorovič</h3>
            <p className="text-cyan-600 font-medium mb-3">Enterprise AI Architect</p>
            <p className="text-gray-600 text-sm mb-4">
              Expert in AI systems design and enterprise-scale deployments.
              Leading technical innovation.
            </p>
            <div className="flex justify-center gap-3">
              <a href="#" className="text-gray-400 hover:text-cyan-600 transition">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="mb-16">
        <div className="bg-gradient-to-r from-blue-600 to-indigo-600 rounded-2xl p-8 lg:p-12 text-white">
          <h2 className="text-3xl font-bold text-center mb-8">Our Culture & Values</h2>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-4 bg-white/20 rounded-full flex items-center justify-center">
                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2">Innovation First</h3>
              <p className="text-blue-100 text-sm">
                We challenge the status quo and embrace bold ideas that push boundaries.
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-4 bg-white/20 rounded-full flex items-center justify-center">
                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2">Customer Obsessed</h3>
              <p className="text-blue-100 text-sm">
                Every decision starts with how it benefits our users and their success.
              </p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-4 bg-white/20 rounded-full flex items-center justify-center">
                <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <h3 className="text-xl font-semibold mb-2">Trust & Transparency</h3>
              <p className="text-blue-100 text-sm">
                We build trust through open communication and transparent practices.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Join Us Section */}
      <section className="text-center">
        <div className="bg-white/80 backdrop-blur-sm rounded-2xl shadow-xl p-8 lg:p-12">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">Join Our Mission</h2>
          <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
            We're always looking for talented individuals who share our passion for innovation 
            and want to make a real impact in the data center industry.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="mailto:careers@finderz.ai" 
              className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-8 py-3 rounded-xl hover:shadow-lg transform hover:scale-105 transition duration-300 font-medium"
            >
              View Open Positions
            </a>
            <a 
              href="mailto:careers@finderz.ai" 
              className="border-2 border-blue-600 text-blue-600 px-8 py-3 rounded-xl hover:bg-blue-50 transition duration-300 font-medium"
            >
              Send Your Resume
            </a>
          </div>
        </div>
      </section>

      <div className="mt-12 text-center">
        <Link 
          to="/" 
          className="text-gray-600 hover:text-blue-600 transition duration-300 font-medium"
        >
          ← Back to Home
        </Link>
      </div>
    </div>

    {/* Footer */}
    <footer className="bg-white/80 backdrop-blur-sm mt-12">
      <div className="mx-auto max-w-7xl px-6 py-8 md:flex md:items-center md:justify-between lg:px-8">
        <div className="mt-4 md:order-1 md:mt-0">
          <p className="text-center text-xs leading-5 text-gray-500">
            &copy; 2025 Finderz AI. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  </div>
  );
};
